import React from "react";
import "./Spinner.css";

const Spinner = () => {
  return (
    <div class="loading">
      <div class="loader"></div>
    </div>
  );
};

export default Spinner;
